/**
 * Lenis smooth scroll for #smooth-wrapper + GSAP ScrollTrigger sync.
 * Lenis loads from the scrolling-borders section only when border art is active for this URL.
 */
(function () {
  if (typeof ScrollTrigger === "undefined") {
    return;
  }

  const wrapper = document.querySelector("#smooth-wrapper");
  const content = document.querySelector("#smooth-content");

  function refreshScrollTrigger() {
    ScrollTrigger.refresh();
  }

  const prefersReduced =
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (!wrapper || !content || prefersReduced) {
    if (document.readyState === "complete") {
      refreshScrollTrigger();
    } else {
      window.addEventListener("load", refreshScrollTrigger);
    }
    window.addEventListener("resize", refreshScrollTrigger);
    return;
  }

  if (typeof window.Lenis === "undefined" || typeof gsap === "undefined") {
    if (document.readyState === "complete") {
      refreshScrollTrigger();
    } else {
      window.addEventListener("load", refreshScrollTrigger);
    }
    window.addEventListener("resize", refreshScrollTrigger);
    return;
  }

  document.documentElement.classList.add(
    "lenis",
    "lenis-smooth",
    "sv-lenis-active"
  );

  var lenisLerp = 0.12;

  var lenis = new window.Lenis({
    wrapper: wrapper,
    content: content,
    smoothWheel: true,
    // Default syncTouch is false: touch is skipped before scrollTo, while CSS keeps
    // #smooth-wrapper overflow-y hidden — mobile then cannot scroll at all.
    syncTouch: true,
    lerp: lenisLerp
  });

  window.lenis = lenis;

  /**
   * Lenis only listens to wheel/touch; #smooth-wrapper uses overflow-y:hidden while active,
   * so native keyboard scrolling never targets it. Map keys to lenis.scrollTo.
   */
  function shouldIgnoreKeyboardScrollTarget(target) {
    if (!target || target.nodeType !== Node.ELEMENT_NODE) return false;
    if (!target.closest) return false;
    if (
      target.closest(
        "iframe, [contenteditable='true'], [contenteditable='plaintext-only']"
      )
    ) {
      return true;
    }
    var control = target.closest(
      "input, textarea, select, option, [role='combobox'], [role='textbox'], [role='searchbox'], [role='spinbutton'], [role='slider'], [role='listbox']"
    );
    if (control) {
      if (control.tagName === "INPUT") {
        var type = (control.type || "").toLowerCase();
        if (
          type === "checkbox" ||
          type === "radio" ||
          type === "button" ||
          type === "submit" ||
          type === "reset" ||
          type === "file" ||
          type === "hidden"
        ) {
          return true;
        }
      }
      return true;
    }
    return false;
  }

  function onLenisKeydown(e) {
    if (e.defaultPrevented) return;
    if (e.ctrlKey || e.metaKey || e.altKey) return;
    if (lenis.isStopped || lenis.isLocked) return;

    var code = e.code;
    if (
      code !== "ArrowUp" &&
      code !== "ArrowDown" &&
      code !== "PageUp" &&
      code !== "PageDown" &&
      code !== "Home" &&
      code !== "End" &&
      code !== "Space"
    ) {
      return;
    }

    if (shouldIgnoreKeyboardScrollTarget(e.target)) return;

    if (
      code === "Space" &&
      e.target.closest &&
      e.target.closest(
        "button, [role='button'], summary, a[href], input, select, textarea"
      )
    ) {
      return;
    }

    var clientH = wrapper.clientHeight;
    var line = Math.round(Math.max(48, clientH * 0.065));
    var page = Math.round(clientH * 0.925);
    var delta = 0;

    if (code === "ArrowDown") delta = line;
    else if (code === "ArrowUp") delta = -line;
    else if (code === "PageDown") delta = page;
    else if (code === "PageUp") delta = -page;
    else if (code === "Space") delta = e.shiftKey ? -page : page;
    else if (code === "Home") {
      e.preventDefault();
      lenis.scrollTo(0, { programmatic: false, lerp: lenisLerp });
      return;
    } else if (code === "End") {
      e.preventDefault();
      lenis.scrollTo(lenis.limit, { programmatic: false, lerp: lenisLerp });
      return;
    }

    var next = lenis.targetScroll + delta;
    next = Math.max(0, Math.min(lenis.limit, next));
    if (next === lenis.targetScroll) return;

    e.preventDefault();
    lenis.scrollTo(next, { programmatic: false, lerp: lenisLerp });
  }

  window.addEventListener("keydown", onLenisKeydown, false);

  lenis.on("scroll", ScrollTrigger.update);

  gsap.ticker.add(function (time) {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);

  ScrollTrigger.scrollerProxy(wrapper, {
    scrollTop: function (value) {
      if (arguments.length) {
        lenis.scrollTo(value, { immediate: true });
      }
      return lenis.scroll;
    },
    getBoundingClientRect: function () {
      return wrapper.getBoundingClientRect();
    },
    pinType: wrapper.style.transform ? "transform" : "fixed"
  });

  if (typeof ScrollTrigger.addEventListener === "function") {
    ScrollTrigger.addEventListener("refreshInit", function () {
      lenis.resize();
    });
  }

  if (document.readyState === "complete") {
    lenis.resize();
    refreshScrollTrigger();
  } else {
    window.addEventListener("load", function () {
      lenis.resize();
      refreshScrollTrigger();
    });
  }

  window.addEventListener("resize", function () {
    lenis.resize();
    refreshScrollTrigger();
  });
})();
